export default __webpack_public_path__ + "static/media/aone-logo.81c9de0c.svg";